import { buildSpectateUrl } from '~spa/Utils/Spectate';
import { post } from '~shared/utils/http';

export const generateBetGeniusEventHandler = (handleError, eventId) => (event) => {
    const { detail: eventDetail = {} } = event || {};
    const { type: eventType = '', body: details = {} } = eventDetail;

    if (eventType === 'player_ready') {
        const data = {
            ...details,
            eventId,
        };

        const url = buildSpectateUrl('/bg_streaming/player');
        post(url, data)
        .then(response => {
            if(response?.ok) {
                return response.json();
            }
            throw new Error(response?.statusText);
        })
        .then((data) => {
            if(!window.GeniusLivePlayer?.player) {
                throw new Error();
            }

            window.GeniusLivePlayer.player.start(data);
        }).catch((error) => {
            console.error(error); //eslint-disable-line

            if(handleError) {
                handleError(true);
            }
        });
    }
};
